import { gql } from "@apollo/client";
import { JOB_PREFERENCES_FRAGMENT } from "./queries";

export const SET_JOB_PREFERENCE = gql`
  mutation setJobPreference($input: SetJobPreferenceInput!) {
    setJobPreference(input: $input) {
      ...JobPreferencesFragment
    }
  }
  ${JOB_PREFERENCES_FRAGMENT}
`;
